import type {FormTypes} from './types';
import type {AiraloSettings} from '@chekin/core';
import * as Sentry from '@sentry/react';

type Props = {
  data: FormTypes;
  reservationId: string;
  housingId: string;
  airaloSettings?: AiraloSettings;
};
export const buildCreateEsimOrderPayload = ({
  data,
  reservationId,
  housingId,
  airaloSettings,
}: Props) => {
  if (!airaloSettings) {
    console.error('Airalo settings are not found');
    Sentry.captureException('Airalo settings are not found');
    return [];
  }

  const orders = Object.entries(data)
    .filter(([, value]) => value.checked)
    .map(([key, value]) => ({
      package_id: key,
      quantity: value.count,
    }));

  return orders.map(order => ({
    package_id: order.package_id,
    quantity: order.quantity,
    manager_profit: airaloSettings.airalo_profit,
    manager_vat: airaloSettings.vat,
    currency: airaloSettings.currency?.toUpperCase(),
    core_reservation_id: reservationId,
    core_housing_id: housingId,
  }));
};
